import * as Actions from '../Actions';

const initialState = {
    conteudo: null,
};

const PainelFixoDireitaReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.CONTEUDO_PAINEL_FIXO:
            {
                return {
                    ...state,
                    conteudo: action.conteudo
                };
            }
        default:
            {
                return state;
            }
    }
};

export default PainelFixoDireitaReducer;
